// extracted by mini-css-extract-plugin
module.exports = {"ownerApplication":"style_ownerApplication__1-CXh"};